import React, { useState, useEffect } from 'react';
import { getDateAgo } from '@repo/common';

const TimeAgo = ({ timestamp }) => {
  const [timeAgo, setTimeAgo] = useState(getDateAgo(timestamp));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo((prev) => {
        const newTime = getDateAgo(timestamp);
        return prev === newTime ? prev : newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return <span className='text-grayscale-gray05'>{timeAgo}</span>;
};

export default TimeAgo;
